import React, { FC } from 'react';
import { DATA_HOOK } from '../../ListItemAction.constants';
import { classes, st } from '../../ListItemAction.st.css';
import { ListItemActionProps } from '../../ListItemAction.types';

type ListItemActionSuffixIconProps = Required<
  Pick<ListItemActionProps, 'suffixIcon'>
> &
  Pick<ListItemActionProps, 'size' | 'subtitle'>;

export const Icon: FC<ListItemActionSuffixIconProps> = ({
  suffixIcon,
  size,
  subtitle,
}) => {
  return React.cloneElement(suffixIcon, {
    size: size === 'medium' ? 24 : 18,
    className: st(classes.suffixIcon, { subtitle: Boolean(subtitle) }),
    'data-hook': DATA_HOOK.suffixIcon,
  });
};
